import __var_0__ from '@stdlib/assert/is-positive-integer';
import __var_1__ from '@stdlib/stats/incr/mmean';
import __var_2__ from '@stdlib/math/base/special/abs';
import __var_3__ from '@stdlib/math/base/special/atan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPositiveInteger = __var_0__.isPrimitive;
var incrmmean = __var_1__;
var abs = __var_2__;
var atan = __var_3__;


// MAIN //

/**
* Returns an accumulator function which incrementally computes a moving mean arctangent absolute percentage error.
*
* @param {PositiveInteger} W - window size
* @throws {TypeError} must provide a positive integer
* @returns {Function} accumulator function
*
* @example
* var accumulator = incrmmaape( 3 );
*
* var m = accumulator();
* // returns null
*
* m = accumulator( 2.0, 3.0 );
* // returns ~0.32
*
* m = accumulator( 5.0, 2.0 );
* // returns ~0.65
*
* m = accumulator( 3.0, 2.0 );
* // returns ~0.59
*
* m = accumulator( 2.0, 5.0 );
* // returns ~0.66
*
* m = accumulator();
* // returns ~0.66
*/
function incrmmaape( W ) {
	var mean;
	if ( !isPositiveInteger( W ) ) {
		throw new TypeError( 'invalid argument. Must provide a positive integer. Value: `' + W + '`.' );
	}
	mean = incrmmean( W );
	return accumulator;

	/**
	* If provided input values, the accumulator function returns an updated mean arctangent absolute percentage error. If not provided input values, the accumulator function returns the current mean arctangent absolute percentage error.
	*
	* @private
	* @param {number} [f] - input value
	* @param {number} [a] - input value
	* @returns {(number|null)} mean arctangent absolute percentage error or null
	*/
	function accumulator( f, a ) {
		if ( arguments.length === 0 ) {
			return mean();
		}
		return mean( atan( abs( (a-f)/a ) ) );
	}
}


// EXPORTS //
export default incrmmaape;
